import React from "react";

import { customIcon } from "./custom-icon";
import styles from "./step-backward.module.css";

const stepBackwardPath = () => (
  <g className={styles.stepBackward}>
    <line x1="3" y1="3" x2="3" y2="17" strokeLinecap="round" />
    <path
      d="M16 10c0-.36-.2-.67-.49-.84l.01-.01-10-6-.01.01A.991.991 0 005 3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1 .19 0 .36-.07.51-.16l.01.01 10-6-.01-.01c.29-.17.49-.48.49-.84z"
      transform={"rotate(180, 10, 10)"}
    />
  </g>
);

export const stepBackwardIcon = customIcon({ path: stepBackwardPath() });
